import React, { useState } from 'react';
import { AreaChart, Area, BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const weeklyJobGrowthData = [{
  name: 'Week 1',
  posted: 38,
  completed: 25
}, {
  name: 'Week 2',
  posted: 42,
  completed: 28
}, {
  name: 'Week 3',
  posted: 45,
  completed: 32
}, {
  name: 'Week 4',
  posted: 40,
  completed: 30
}];
const monthlyJobGrowthData = [{
  name: 'Jan',
  posted: 65,
  completed: 42
}, {
  name: 'Feb',
  posted: 78,
  completed: 50
}, {
  name: 'Mar',
  posted: 90,
  completed: 63
}, {
  name: 'Apr',
  posted: 81,
  completed: 59
}, {
  name: 'May',
  posted: 95,
  completed: 71
}, {
  name: 'Jun',
  posted: 110,
  completed: 82
}, {
  name: 'Jul',
  posted: 120,
  completed: 90
}, {
  name: 'Aug',
  posted: 130,
  completed: 93
}, {
  name: 'Sep',
  posted: 142,
  completed: 101
}, {
  name: 'Oct',
  posted: 155,
  completed: 118
}, {
  name: 'Nov',
  posted: 162,
  completed: 127
}, {
  name: 'Dec',
  posted: 170,
  completed: 135
}];
const yearlyJobGrowthData = [{
  name: '2020',
  posted: 856,
  completed: 542
}, {
  name: '2021',
  posted: 1024,
  completed: 698
}, {
  name: '2022',
  posted: 1189,
  completed: 823
}, {
  name: '2023',
  posted: 1356,
  completed: 956
}, {
  name: '2024',
  posted: 1524,
  completed: 1089
}];
const weeklyRevenueData = [{
  name: 'Week 1',
  revenue: 6200
}, {
  name: 'Week 2',
  revenue: 7100
}, {
  name: 'Week 3',
  revenue: 7800
}, {
  name: 'Week 4',
  revenue: 7300
}];
const monthlyRevenueData = [{
  name: 'Jan',
  revenue: 12500
}, {
  name: 'Feb',
  revenue: 14800
}, {
  name: 'Mar',
  revenue: 16200
}, {
  name: 'Apr',
  revenue: 15900
}, {
  name: 'May',
  revenue: 17500
}, {
  name: 'Jun',
  revenue: 19200
}, {
  name: 'Jul',
  revenue: 21000
}, {
  name: 'Aug',
  revenue: 22400
}, {
  name: 'Sep',
  revenue: 25800
}, {
  name: 'Oct',
  revenue: 27300
}, {
  name: 'Nov',
  revenue: 29100
}, {
  name: 'Dec',
  revenue: 31500
}];
const yearlyRevenueData = [{
  name: '2020',
  revenue: 185000
}, {
  name: '2021',
  revenue: 224000
}, {
  name: '2022',
  revenue: 268000
}, {
  name: '2023',
  revenue: 312000
}, {
  name: '2024',
  revenue: 356000
}];
const weeklyCompletionData = [{
  name: 'Week 1',
  completed: 25,
  cancelled: 4
}, {
  name: 'Week 2',
  completed: 28,
  cancelled: 5
}, {
  name: 'Week 3',
  completed: 32,
  cancelled: 6
}, {
  name: 'Week 4',
  completed: 30,
  cancelled: 5
}];
const monthlyCompletionData = [{
  name: 'Jan',
  completed: 42,
  cancelled: 8
}, {
  name: 'Feb',
  completed: 50,
  cancelled: 10
}, {
  name: 'Mar',
  completed: 63,
  cancelled: 12
}, {
  name: 'Apr',
  completed: 59,
  cancelled: 9
}, {
  name: 'May',
  completed: 71,
  cancelled: 11
}, {
  name: 'Jun',
  completed: 82,
  cancelled: 13
}, {
  name: 'Jul',
  completed: 90,
  cancelled: 15
}, {
  name: 'Aug',
  completed: 93,
  cancelled: 14
}, {
  name: 'Sep',
  completed: 101,
  cancelled: 16
}, {
  name: 'Oct',
  completed: 118,
  cancelled: 18
}, {
  name: 'Nov',
  completed: 127,
  cancelled: 20
}, {
  name: 'Dec',
  completed: 135,
  cancelled: 19
}];
const yearlyCompletionData = [{
  name: '2020',
  completed: 542,
  cancelled: 95
}, {
  name: '2021',
  completed: 698,
  cancelled: 118
}, {
  name: '2022',
  completed: 823,
  cancelled: 142
}, {
  name: '2023',
  completed: 956,
  cancelled: 168
}, {
  name: '2024',
  completed: 1089,
  cancelled: 195
}];
export const ChartSection = () => {
  const [timeframe, setTimeframe] = useState('monthly');
  const jobGrowthData = timeframe === 'weekly' ? weeklyJobGrowthData : timeframe === 'monthly' ? monthlyJobGrowthData : yearlyJobGrowthData;
  const revenueData = timeframe === 'weekly' ? weeklyRevenueData : timeframe === 'monthly' ? monthlyRevenueData : yearlyRevenueData;
  const completionData = timeframe === 'weekly' ? weeklyCompletionData : timeframe === 'monthly' ? monthlyCompletionData : yearlyCompletionData;
  return <div className="mb-8" data-id="element-51">
      <div className="flex items-center justify-between mb-4" data-id="element-52">
        <h2 className="text-lg font-semibold text-gray-800" data-id="element-53">Analytics</h2>
        <div className="flex space-x-2" data-id="element-54">
          <TimeframeButton active={timeframe === 'weekly'} onClick={() => setTimeframe('weekly')} data-id="element-55">
            Weekly
          </TimeframeButton>
          <TimeframeButton active={timeframe === 'monthly'} onClick={() => setTimeframe('monthly')} data-id="element-56">
            Monthly
          </TimeframeButton>
          <TimeframeButton active={timeframe === 'yearly'} onClick={() => setTimeframe('yearly')} data-id="element-57">
            Yearly
          </TimeframeButton>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-58">
        <ChartCard title="Job Growth Trends" data-id="element-59">
          <ResponsiveContainer width="100%" height={300} data-id="element-60">
            <AreaChart data={jobGrowthData} margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0
          }} data-id="element-61">
              <defs data-id="element-62">
                <linearGradient id="colorPosted" x1="0" y1="0" x2="0" y2="1" data-id="element-63">
                  <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8} data-id="element-64" />
                  <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} data-id="element-65" />
                </linearGradient>
                <linearGradient id="colorCompleted" x1="0" y1="0" x2="0" y2="1" data-id="element-66">
                  <stop offset="5%" stopColor="#10b981" stopOpacity={0.8} data-id="element-67" />
                  <stop offset="95%" stopColor="#10b981" stopOpacity={0} data-id="element-68" />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" data-id="element-69" />
              <YAxis data-id="element-70" />
              <CartesianGrid strokeDasharray="3 3" data-id="element-71" />
              <Tooltip data-id="element-72" />
              <Legend data-id="element-73" />
              <Area type="monotone" dataKey="posted" name="Jobs Posted" stroke="#3b82f6" fillOpacity={1} fill="url(#colorPosted)" data-id="element-74" />
              <Area type="monotone" dataKey="completed" name="Jobs Completed" stroke="#10b981" fillOpacity={1} fill="url(#colorCompleted)" data-id="element-75" />
            </AreaChart>
          </ResponsiveContainer>
        </ChartCard>
        <ChartCard title="Revenue Over Time" data-id="element-76">
          <ResponsiveContainer width="100%" height={300} data-id="element-77">
            <LineChart data={revenueData} margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0
          }} data-id="element-78">
              <CartesianGrid strokeDasharray="3 3" data-id="element-79" />
              <XAxis dataKey="name" data-id="element-80" />
              <YAxis tickFormatter={value => `$${value / 1000}k`} data-id="element-81" />
              <Tooltip formatter={value => [`$${value.toLocaleString()}`, 'Revenue']} data-id="element-82" />
              <Legend data-id="element-83" />
              <Line type="monotone" dataKey="revenue" name="Revenue" stroke="#8b5cf6" strokeWidth={2} dot={{
              r: 4
            }} activeDot={{
              r: 6
            }} data-id="element-84" />
            </LineChart>
          </ResponsiveContainer>
        </ChartCard>
      </div>
      <ChartCard title="Cancellations vs Completions" data-id="element-85">
        <ResponsiveContainer width="100%" height={300} data-id="element-86">
          <BarChart data={completionData} margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0
        }} data-id="element-87">
            <CartesianGrid strokeDasharray="3 3" data-id="element-88" />
            <XAxis dataKey="name" data-id="element-89" />
            <YAxis data-id="element-90" />
            <Tooltip data-id="element-91" />
            <Legend data-id="element-92" />
            <Bar dataKey="completed" name="Completed Jobs" fill="#10b981" radius={[4, 4, 0, 0]} data-id="element-93" />
            <Bar dataKey="cancelled" name="Cancelled Jobs" fill="#ef4444" radius={[4, 4, 0, 0]} data-id="element-94" />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>
    </div>;
};
const TimeframeButton = ({
  active,
  children,
  onClick
}) => {
  return <button onClick={onClick} className={`px-3 py-1.5 text-sm font-medium rounded ${active ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-95">
      {children}
    </button>;
};
const ChartCard = ({
  title,
  children
}) => {
  return <div className="bg-white rounded-lg shadow border border-gray-100 p-5" data-id="element-96">
      <h3 className="text-base font-medium text-gray-700 mb-4" data-id="element-97">{title}</h3>
      {children}
    </div>;
};